/**
 * Extracts a readable message from an Axios error.
 *
 * Protects against cases where the backend returns an object instead of a string
 * in the error/message fields — otherwise '[object Object]' ends up in the UI.
 *
 * Search order:
 *   1. response.data.error (if it is a string)
 *   2. response.data.message (if it is a string)
 *   3. If error/message is an object, tries .message / .text inside it,
 *      otherwise uses JSON.stringify
 *   4. fallback (passed as the second argument)
 */
export const extractErrorMessage = (error: any, fallback: string): string => {
    const respData = error && error.response && error.response.data
    if (!respData) return fallback

    const candidate = respData.error || respData.message
    if (!candidate) return fallback

    if (typeof candidate === 'string') return candidate

    if (typeof candidate === 'object') {
        if (typeof candidate.message === 'string') return candidate.message
        if (typeof candidate.text === 'string') return candidate.text
        try {
            return JSON.stringify(candidate)
        } catch (e) {
            return fallback
        }
    }

    return fallback
}
